import axios from 'axios';
import select from './select';
import imgLoader from './img-loader';
import { $, endPoint, findTarget, dataExist, loading } from '../utils/Utils';

const resellerFinder = (() => {
  const triggers = [...$('.js-resellerFinder')];
  const targetCN = 'js-resellerFinderTarget';
  const parent = 'js-resellerFinderParent';

  const createMarkup = office => `
    ${(dataExist(office, 'title')) ? `<h3 class="officeDetails__title">${office.title}</h3>` : ''}
    ${(dataExist(office, 'content')) ? `<div class="officeDetails__text">${office.content}</div>` : ''}
    ${(dataExist(office, 'employees')) ? `
    <ul class="listPerson grid -pad -collapse">
      ${office.employees.map((employee, i) => `
        <li class="listPerson__listItem grid__column -iphone-6 -portrait-4" style="animation-delay: ${i * 400}ms;">
          <div class="listPerson__img imgLoader imgLoader__placeholder ${(dataExist(employee, 'thumbnail')) ? `${(employee.thumbnail) ? `js-imgLoadTrigger" data-href="${employee.thumbnail}` : ''}` : ''}"></div>
          ${(dataExist(employee, 'name')) ? `<h3 class="listPerson__details -name">${employee.name}</h3>` : ''}
          ${(dataExist(employee.contact, 'phone')) ? `<p class="listPerson__details -phone">${employee.contact.phone}</p>` : ''}
          ${(dataExist(employee.contact, 'email')) ? `<p class="listPerson__details -email"><a href="mailto:${employee.contact.email}">E-post</a></p>` : ''}
        </li>
      `).join('')}
    </ul>` : ''}
    ${(dataExist(office, 'visit') || dataExist(office, 'contact')) ? `
      <div class="grid -pad -collapse">
        ${(dataExist(office, 'visit')) ? `
        <div class="grid__column -ipad-6 officeDetails__contact">
          <h4 class="title">Postadress:</h4>
          <p>${(dataExist(office.visit, 'address')) ? `${office.visit.address}<br>` : ''}
          ${(dataExist(office.visit, 'zip')) ? `${office.visit.zip} ` : ''}
          ${(dataExist(office.visit, 'city')) ? `${office.visit.city}` : ''}</p>
        </div>` : ''}
        ${(dataExist(office, 'contact')) ? `${
          office.contact.map(contact => `
            <div class="grid__column -ipad-6 officeDetails__contact">
              ${(dataExist(contact, 'title')) ? `<h4 class="title">${contact.title}</h4>`: ''}
              <p>
                ${(dataExist(contact, 'phone')) ? `Telefon: ${contact.phone}<br>` : ''}
                ${(dataExist(contact, 'email')) ? `E-post: <a href="mailto:${contact.email}">${contact.email}</a>` : ''}
              </p>
            </div>
          `).join('')}
        ` : ''}
      </div>
    `: ''}`;

  const handleMarkup = ({ data, target }) => {
    target.innerHTML = createMarkup(data[0]);

    // lazy load all thumbnails (employees photos)
    imgLoader.init();
  };

  const handleChange = (trigger) => {
    const route = `${endPoint.reseller}/${select.getValue(trigger)}`;
    const target = findTarget({ element: trigger, parent, target: targetCN });

    loading.show(target);

    axios
      .get(route)
      .then((response) => {
        loading.stop(target);

        if (response.data) {
          handleMarkup({ target, data: response.data });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const build = () => {
    triggers.forEach((trigger) => {
      trigger.addEventListener('change', () => handleChange(trigger));
    });
  };

  const setOption = (selectElement, value) => {
    return [...selectElement.options].some((option, index) => {
      if (option.value === value) {
        selectElement.selectedIndex = index;
        selectElement.dispatchEvent(new Event('change'));
        return true;
      }
      return false;
    });
  };

  const selectQueryStringReseller = () => {
    const searchParams = new URLSearchParams(document.location.search);
    const param = searchParams.get('place');

    if (param) {
      setOption(triggers[0], param);
    }
  };

  const init = () => {
    if (triggers.length > 0) {
      build();
      selectQueryStringReseller();
    }
  };

  return {
    init,
  };
})();


export default resellerFinder.init();



// WEBPACK FOOTER //
// ./components/reseller-finder.js